import { tokens } from '@neo4j-ndl/base';

export const NVL_DARK_MODE_DISABLED_ITEM_COLOR = tokens.colors.neutral['65'];

export const NVL_DARK_MODE_DISABLED_ITEM_FONT_COLOR = tokens.colors.neutral['55'];
export const DEFAULT_NVL_DISABLED_COLOR = '#EDEDED';
